import { format, parseISO, Locale } from 'date-fns'
import * as locales from 'date-fns/locale'
import i18n from 'i18next'
import { isDate } from 'lodash-es'

/**
 * Copied verbatim from @/utils/formatDateTime so the AiChatBot tools tree has no
 * @/utils app-internal import. Behaviour is byte-identical — depends only on the
 * date-fns / i18next / lodash-es npm libraries, no host coupling.
 */
const DEFAULT_DATE_TIME_FORMAT = 'eee, PPp'

export const formatDateTime = (
  time: unknown,
  dateFormat: string = DEFAULT_DATE_TIME_FORMAT,
) => {
  if (isDate(time)) {
    return format(time, dateFormat, {
      locale: getLocale(),
    })
  }
  if (typeof time === 'string') {
    return format(parseISO(time), dateFormat, {
      locale: getLocale(),
    })
  }
  if (time != null) {
    return time + ''
  }
  return ''
}

const getLocale = () => {
  return (locales as { [key: string]: Locale })[i18n.language]
}
